import { useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import { updateSubscription } from '../../reducers/subscription';
import { completeStep } from '../../reducers/steps';
import { calculateShipping } from '../../services/shipping';
import { trackPageView } from '../../services/tracking';
import { updateReducerAndForm } from '../../services/subscription';
import quantities from './quantities';

import { Input } from '../input';
import { Button } from '../button';
import { FormActions } from '../formActions';
import { PageHeader } from '../pageHeader';
import { PageBack } from '../pageBack';

import Summary from '../summary';

function CustomQuantity(props){
  const formikRef = useRef();
  const dispatch = useDispatch();

  const subscription = useSelector((state) => state.subscription);
  const initialValues = { ...subscription };

  const steps = useSelector((state) => state.steps);

  let backUrl, backDescription;
  if(steps[2].complete){
    backUrl = '/perfil';
    backDescription = 'Dados pessoais';
  }
  else {
    backUrl = '/plano';
    backDescription = 'Sua caixinha';
  }

  const validate = (values) => {
    const errors = {};

    if (!values.quantity){
      errors.quantity = 'Escolha uma quantidade para continuar';
    }

    return errors;
  }

  const handleChange = async (e) => {
    await updateReducerAndForm({
      quantity: parseInt(e.target.value),
    }, formikRef.current.setFieldValue);

    calculateShipping(formikRef.current.values.zipcode, formikRef.current.values.quantity);
  }

  const handleSubmit = (values) => {
    dispatch(completeStep(2));

    props.history.push('/entrega');
  }

  useEffect(() => {
    dispatch(updateSubscription({ planPage: 'customQuantity' }));

    updateReducerAndForm({
      orderType: 2,
      coffees: {},
    }, formikRef.current.setFieldValue);

    trackPageView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        validate={validate}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue, values }) => (
          <Form>
            <PageHeader>
              <small>Sua caixinha</small>
              <h1>Quantos pacotes você quer receber?</h1>
              <p>1 pacote = 2 semanas de café para uma pessoa.</p>
            </PageHeader>

            <PageBack to="/plano" text="Voltar" />

            <Input
              label="Sua quantidade ideal"
              name="quantity"
              as="select"
              includeBlank={false}
              options={quantities}
              onChange={handleChange}
            />

            <Summary />

            <FormActions backUrl={backUrl} backDescription={backDescription}>
              <Button
                type="submit"
                icon="angle-right"
                align="right"
                description="Frequência"
              >
                Continuar
              </Button>
            </FormActions>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default withRouter(CustomQuantity);
